import React, { forwardRef } from 'react';

import { Divider } from 'common/common-components.styled';
import BaseButton from 'components/base-button';

import { NotificationsDrawerTrigger } from 'widgets/notifications';

import { SIDE_MENU_ACTION_BAR_VERTICAL_HEIGHT, SIDE_MENU_ACTION_BAR_HORIZONTAL_HEIGHT } from '../constants';
import { StyledDoubleRightArrow } from '../side-menu.styled';
import { StyledActions, SideMenuActionBarContainer } from '../side-menu.styled';

type SideMenuActionBarProps = {
  isMinimized: boolean;
  onToggleMinimized: () => void;
};

const SideMenuActionBar = forwardRef<HTMLDivElement, SideMenuActionBarProps>(function SideMenuActionBar(
  { isMinimized, onToggleMinimized },
  ref
) {
  return (
    <SideMenuActionBarContainer isMinimized={isMinimized} ref={ref}>
      <Divider color='grey50' margin='0 15px' />
      <StyledActions
        id='expandViewSwitcher'
        direction={isMinimized ? 'column' : 'row'}
        align='center'
        padding={'0 15px'}
        height={
          isMinimized ? `${SIDE_MENU_ACTION_BAR_VERTICAL_HEIGHT}px` : `${SIDE_MENU_ACTION_BAR_HORIZONTAL_HEIGHT}px`
        }
        justify={isMinimized ? 'center' : 'space-between'}
        aria-label={isMinimized ? 'Expand side menu' : 'Collapse side menu'}
        aria-expanded={!isMinimized}
        tabIndex={0}
        gap='15px'
      >
        <NotificationsDrawerTrigger />
        <BaseButton style={{ marginLeft: 'auto' }} icon variant='tertiary' onClick={onToggleMinimized}>
          <StyledDoubleRightArrow isMinimized={isMinimized} width={16} height={16} />
        </BaseButton>
      </StyledActions>
    </SideMenuActionBarContainer>
  );
});

export default SideMenuActionBar;
